import { render, staticRenderFns } from "./issueManageRouter.vue?vue&type=template&id=30641ea1&"
import script from "./issueManageRouter.vue?vue&type=script&lang=js&"
export * from "./issueManageRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports